$(document).ready(function(){
  
  // Right-to-Left Marquee
  $('.right_to_left').slick({
    slidesToShow: 19,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,  // makes it continuous
    speed: 9000,       // adjust for marquee speed
    cssEase: 'linear',
    infinite: true,
    rtl: true,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 15 }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 12 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 10 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 6 }
      }
    ]
  });

  // Left-to-Right Marquee
  $('.left_to_right').slick({
    slidesToShow: 19,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 9000,
    cssEase: 'linear',
    infinite: true,
    rtl: false,
    arrows: false,
    dots: false,
    responsive: [
       {
        breakpoint: 1440,
        settings: { slidesToShow: 15 }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 12 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 10 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 6 }
      }
    ]
  });

  // Main Expert Slider
  $('.main_expert').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 9000,
    cssEase: 'linear',
    infinite: true,
    rtl: false,
    arrows: false,
    dots: false,
    draggable: true,

    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 6 }
      },
      {
        breakpoint: 1400,
        settings: { slidesToShow: 5 }
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4 }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 3,
                    draggable: true
         }
      },
      {
        breakpoint: 768,
        settings: { 
          draggable: true,
          swipe: true,
          swipeToSlide: true,
          touchMove: true,
          slidesToShow: 3 
        }
      }
    ]
  });


   $('.main-bg-content.mobile-only').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 0,
  infinite: false,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 }
      }
    ]
  });



    $('.mobile-biotic-only').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 0,
    centerPadding: '0px',     
    //  speed: 9000,
    // cssEase: 'linear',
    // infinite: true,
    rtl: false,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 6 }
      },
      {
        breakpoint: 1400,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 }
      }
    ]
  });
});

